@layer token {
  :root {
    /* BASE ----------------------------------------------------------------- */
    --n-toast-container-width: 100%;
    --n-toast-container-width-max: 360px;
    --n-toast-container-padding: var(--n-scale-600);
  }
}

@layer component {
  /* BASE ------------------------------------------------------------------- */

  .group {
    z-index: var(--n-layer-max);
    position: fixed;
    overflow-y: auto;
    width: var(--n-toast-container-width);
    max-height: calc(100dvh - var(--n-toast-container-padding) * 2);
    padding: var(--n-toast-container-padding);
    pointer-events: none; /* Allow clicking through the container */

    @media (--mq-sm) {
      max-width: var(--n-toast-container-width-max);
    }
  }

  .group > * {
    pointer-events: auto; /* But enable clicking on actual toasts */
  }

  /* POSITIONS -------------------------------------------------------------- */

  .topLeftPosition {
    top: 0;
    left: 0;
    flex-direction: column-reverse;
  }

  .topCenterPosition {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column-reverse;
  }

  .topRightPosition {
    top: 0;
    right: 0;
    flex-direction: column-reverse;
  }

  .bottomRightPosition {
    bottom: 0;
    right: 0;
    flex-direction: column;
  }

  .bottomCenterPosition {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
  }

  .bottomLeftPosition {
    bottom: 0;
    left: 0;
    flex-direction: column;
  }
}
